import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0","key":"svg-0"}],["path",{"d":"M12 18h-7a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5","key":"svg-1"}],["path",{"d":"M18 12h.01","key":"svg-2"}],["path",{"d":"M6 12h.01","key":"svg-3"}],["path",{"d":"M16 19h6","key":"svg-4"}],["path",{"d":"M19 16l3 3l-3 3","key":"svg-5"}]]

const IconCashBanknoteMove = createReactComponent('outline', 'cash-banknote-move', 'CashBanknoteMove', __iconNode);

export default IconCashBanknoteMove;